import {Observable, throwError as observableThrowError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {Response} from '@angular/http';
import {HttpInterceptorService, RESTService} from '@covalent/http-deprec';

import {MaklerPaket} from '../../index/service/Model/MaklerPaket';
import {environment} from '../../../../environments/environment';
import {Admin} from '../classes/admin';

@Injectable()
export class AdminService extends RESTService<Admin> {

  constructor(public http: HttpInterceptorService) {
    super(http, {
      baseUrl: `${environment.apiHost}`,
      path: 'makpak/findMaklerPakete'
    });
  }

  findMaklerPakete(): Observable<MaklerPaket[]> {
    //debugger;
    return super.get("").pipe(
      map((res: MaklerPaket[]) => {
        console.log("res: " + res);
        return res;
      }));
  }

  getAllAdmins(): Observable<Admin[]> {
    return super.get("alle").pipe(
      map((res: Admin[]) => {
        return res;
      }));
  }

  addNewAdmin(newAdmin: Admin): Observable<Response> {
    const url = this.buildUrl() + "/speichern";
    return this.http
      .put(url, newAdmin).pipe(
        map((res: Response) => {
          return res;
        }));
  }

  deleteAdmin(admin: Admin): Promise<void> {
    const url = this.buildUrl() + "/entfernen?";
    var urlParam = url + "bensl=" + admin.bensl;

    /*
    let params = new URLSearchParams();
    params.append("bensl", admin.bensl);

    let options = new RequestOptions({
      params: params
    });*/

    return this.http
      .delete(urlParam)
      .toPromise()
      .then(() => null);
  }


  isAdmin(bensl: string): Observable<boolean> {
    var urlParam = "ermitteln?";
    urlParam += bensl ? "bensl=" + bensl : "";

    return super.get(urlParam).pipe(
      map((res: any) => {
        return res.bensl && res.bensl.toLowerCase() == bensl.toLowerCase();
      }),
      catchError((e: any) => {
        return observableThrowError(false);
      })
    ); //TODO changed this
      // .catch((e: any) => {
      //   return observableThrowError(false);
      // });
  }
}
